import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import mapValues from "lodash/mapValues";

const mapToIRIRec = value => {
    if (isArray(value)) {
        return value.map(mapToIRIRec);
    }

    if (isObject(value)) {
        if (value["@id"]) {
            return mapToIRIRec(value["@id"]);
        }

        return mapValues(value, mapToIRIRec);
    }

    return value;
};

const normalize = value => mapValues(value, mapToIRIRec);

// Empty inputs (ex: a cleared DateInput) hold "" in redux-form, which the API rejects on
// nullable date fields. Convert them back to null before sending the payload.
const emptyStringsToNull = value => Object.fromEntries(Object.entries(value).map(([k, v]) => [k, v === "" ? null : v]));

const normalizeForApi = value => emptyStringsToNull(normalize(value));

const JSONLD = {
    normalize,
    emptyStringsToNull,
    normalizeForApi,
};

export default JSONLD;
